import { Box, Checkbox, FormGroup } from '@ksyos/design-system';
import { TreatedStatusFilter } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';

interface IRequestStatusFilterProps {
    onChangeTreatedStatus: (value: TreatedStatusFilter | undefined) => void;
    treatedStatus?: TreatedStatusFilter;
}

export function RequestStatusFilter(props: IRequestStatusFilterProps) {
    const language = getSelectedLanguage();

    return (
        <FormGroup
            label={language.request.status}
            sx={{ alignItems: 'center', marginY: '20px !important' }}
        >
            <Box
                display={'flex'}
                gap={9}
            >
                <Checkbox
                    checked={
                        props.treatedStatus === TreatedStatusFilter.treated ||
                        props.treatedStatus === TreatedStatusFilter.both
                    }
                    label={language.common.treated}
                    onChange={() => {
                        switch (props.treatedStatus) {
                            case TreatedStatusFilter.treated:
                                props.onChangeTreatedStatus(undefined);
                                break;
                            case TreatedStatusFilter.toTreat:
                                props.onChangeTreatedStatus(TreatedStatusFilter.both);
                                break;
                            case undefined:
                                props.onChangeTreatedStatus(TreatedStatusFilter.treated);
                                break;
                            default:
                                props.onChangeTreatedStatus(TreatedStatusFilter.toTreat);
                        }
                    }}
                />
                <Checkbox
                    checked={
                        props.treatedStatus === TreatedStatusFilter.toTreat ||
                        props.treatedStatus === TreatedStatusFilter.both
                    }
                    label={language.common.toTreat}
                    onChange={() => {
                        switch (props.treatedStatus) {
                            case TreatedStatusFilter.toTreat:
                                props.onChangeTreatedStatus(undefined);
                                break;
                            case TreatedStatusFilter.treated:
                                props.onChangeTreatedStatus(TreatedStatusFilter.both);
                                break;
                            case undefined:
                                props.onChangeTreatedStatus(TreatedStatusFilter.toTreat);
                                break;
                            default:
                                props.onChangeTreatedStatus(TreatedStatusFilter.treated);
                        }
                    }}
                />
            </Box>
        </FormGroup>
    );
}
